export default __webpack_public_path__ + "images/TA.9fd9330.png";